import { PromoCodeFormSchema } from "@/components/modal/layouts/promo-code-modal/form/models";
import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { PromoCodeResponseDto } from "./models";

export class PromoCodeApi {
  static async sendPromoCode(params: PromoCodeFormSchema) {
    const response = GbApiRequestService.post(
      "userRpc",
      new URLSearchParams({
        type: JSON.stringify({
          dataMap: {
            message: params.code,
          },
          processorClass: "PromoCode",
        }),
      }),
    );

    return withSchemaValidation(response, PromoCodeResponseDto);
  }
}
